export default {"src":"/_next/static/media/right.9ffcccff.svg","height":675,"width":551,"blurWidth":0,"blurHeight":0};